<template>
  <div id="card-wallet-balance" class="card card-rounded card-shadow border-0 mb-3 icon-watermark-top card-with-watermark">
    <div class="card-body">
      <div v-if="canWithdraw">
        <div class="small text-muted">{{ $t('WalletBalance.yourLoanBalance') }}</div>
        <div class="h4 text-body line-height-1 mt-1 mb-0">{{ $n(balance.amount, 'currencyNoDecimals') }}</div>
      </div>
      <div class="py-1">
        <router-link v-if="isEligibleForNewLoan" :to="{name: 'new-loan'}"
                     id="button-new-loan"
                     class="btn btn-sm rounded-pill btn-outline-primary btn-with-icon mt-2 mr-3 mr-xxs-1">
          <Icon icon-class="icon-sm mr-1 ml-n1" icon-name="plus-outline"/>
          <span class="nav-text line-height-1">{{ $t('WalletBalance.newLoan') }}</span>
        </router-link>
        <router-link v-if="canWithdraw" :to="{name: 'wallet-withdraw'}"
                     class="btn btn-sm rounded-pill btn-outline-primary btn-with-icon mt-2" href="javascript:void(0)">
          <Icon icon-class="icon-sm mr-1 ml-n1" icon-name="arrow-downward-outline"></Icon>
          <span class="nav-text line-height-1">{{ $t('WalletBalance.withdraw') }}</span>
        </router-link>
      </div>
      <RecentTransactions v-if="hasRecentTransactionsToShow" :transactions="balance.recentTransactions"/>
    </div>
    <Icon icon-name="iute-pepper-outline" icon-class="icon-watermark"></Icon>
  </div>
</template>

<script>

import Icon from '@shared/components/Icon'
import RecentTransactions from '@shared/components/wallet/RecentTransactions'

export default {
  components: {
    Icon,
    RecentTransactions
  },
  props: ['balance', 'isEligibleForNewLoan'],
  computed: {
    canWithdraw() {
      const payoutBalances = this.balance?.payoutBalances || {}
      return payoutBalances.PAYOUT > 0 || payoutBalances.IUTE_PAYOUT > 0
    },
    hasRecentTransactionsToShow() {
      return this.balance?.recentTransactions?.length > 0
    }
  }
}
</script>
